import { render, staticRenderFns } from "./PanelService.vue?vue&type=template&id=68174360&scoped=true&"
import script from "./PanelService.vue?vue&type=script&lang=js&"
export * from "./PanelService.vue?vue&type=script&lang=js&"
import style0 from "./PanelService.vue?vue&type=style&index=0&id=68174360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68174360",
  null
  
)

export default component.exports